import Avatar from '@mui/material/Avatar'
import Stack from '@mui/material/Stack'
import Text from '@mui/material/Typography'
import Image, { StaticImageData } from 'next/image'
import { ReactNode } from 'react'

const QuoteCard = ({
    quoteText,
    quoteName,
    quoteTitle,
    quoteAvatar,
}: {
    quoteText: ReactNode
    quoteName: string
    quoteTitle: string
    quoteAvatar: StaticImageData
}) => {
    return (
        <Stack
            direction="column"
            justifyContent="center"
            alignItems="stretch"
            sx={{
                padding: {
                    xs: '32px 32px 200px 32px',
                    sm: '32px 32px 200px 32px',
                    md: '72px 40px 240px 40px',
                    lg: '72px 40px 240px 40px',
                    xl: '72px 40px 240px 40px',
                },
            }}
            spacing={{
                xs: 3,
                sm: 4,
                md: 4,
                lg: 4,
                xl: 4,
            }}
        >
            <Stack
                direction="row"
                spacing={{
                    xs: 2,
                    sm: 2,
                    md: 2,
                    lg: 2,
                    xl: 2,
                }}
            >
                <Avatar
                    sx={{
                        height: 48,
                        width: 48,
                        margin: 0,
                    }}
                >
                    <Image src={quoteAvatar} alt={`${quoteTitle} avatar`} />
                </Avatar>
                <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="flex-start"
                    spacing={0.5}
                >
                    <Text
                        variant={'h6'}
                        sx={{
                            fontWeight: 700,
                        }}
                    >
                        {quoteName}
                    </Text>
                    <Text variant={'caption'} component="span">
                        {quoteTitle}
                    </Text>
                </Stack>
            </Stack>
            <Text
                fontSize={{ xs: '18px', sm: '18px', md: '18px', lg: '24px', xl: '24px' }}
                variant={`body1`}
                lineHeight={{
                    xs: '21.6px',
                    sm: '21.6px',
                    md: '21.6px',
                    lg: '33.6px',
                    xl: '33.6px',
                }}
            >
                {quoteText}
            </Text>
        </Stack>
    )
}

export default QuoteCard
